import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Claims from "../pages/claims/page";
import Resources from "../pages/resources/page";
import WorkersCompArticle from "../pages/resources/workers-comp-article/page";
import BuyersGuideArticle from "../pages/resources/buyers-guide-article/page";
import ContractorChecklistArticle from "../pages/resources/contractor-checklist-article/page";
import CoverageEstimator from "../pages/resources/coverage-estimator/page";
import CoalMineInsuranceArticle from "../pages/resources/coal-mine-insurance-article/page";
import HowToFileAClaimArticle from "../pages/resources/how-to-file-a-claim-article/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/claims", element: <Claims /> },
  { path: "/resources", element: <Resources /> },
  { path: "/resources/workers-comp-ky-tn-va", element: <WorkersCompArticle /> },
  { path: "/resources/business-insurance-buyers-guide", element: <BuyersGuideArticle /> },
  { path: "/resources/contractor-insurance-checklist", element: <ContractorChecklistArticle /> },
  { path: "/resources/coverage-estimator", element: <CoverageEstimator /> },
  { path: "/resources/coal-mine-insurance", element: <CoalMineInsuranceArticle /> },
  { path: "/resources/how-to-file-a-claim", element: <HowToFileAClaimArticle /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
